export default __webpack_public_path__ + "c2382ce54b4998be01e3a16491e376dd.jpg";